<template>
  <el-row>
    <section>
      <div class="flex flex-between">
        <div class="title-bc">{{ $t("m.deviceIndex.deviceTypeDetail") }}</div>
        <div class="line-right">
          <el-button
            type="warning"
            v-if="hasAdd == false && !notShowedit"
            @click="saveBeanClick"
            >{{ $t("m.commentDetail.saveChange") }}</el-button
          >
          <el-button
            type="warning"
            v-if="hasAdd == true"
            @click="addBeanClick"
            >{{ $t("m.button.add") }}</el-button
          >
          <el-button
            type="primary"
            v-if="hasAdd == false && !notShowedit"
            @click="beanDeleteClick"
            icon="el-icon-delete"
            class="active-icon"
            >{{ $t("m.commentDetail.delete") }}</el-button
          >
        </div>
      </div>
      <el-form
        ref="beanAddSaveForm"
        :rules="rules"
        :model="beanDetailInfo"
        :disabled="isDisabled"
      >
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <el-form-item prop="productType" style="width: 100%">
              <span class="cus-input-title">{{
                $t("m.systemSetting.productType")
              }}</span>
              <el-select
                placeholder=""
                style="width: 100%"
                v-model="beanDetailInfo.productType"
              >
                <el-option
                  v-for="item in productTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <el-form-item prop="name" style="width: 100%">
              <span class="cus-input-title">{{
                $t("m.commentDetail.name")
              }}</span>
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.name"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex flex-between input-line">
          <div class="flex input-wrap has-title" style="width: 100%">
            <el-form-item prop="note" style="width: 100%;height:300px">
              <span class="cus-input-title">{{
                $t("m.commentDetail.remark")
              }}</span>
              <el-input
                placeholder=""
                type="text"
                v-model="beanDetailInfo.note"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </section>
  </el-row>
</template>

<script>
import { saveAs } from "file-saver";

export default {
  name: "beanDetail",
  props: {
    beanInfo: Object,
    showReportList: Array,
    isAdd: Boolean,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    notShowedit: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      weight: "kg",
      datePickOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      hasAdd: false,
      hasReportList: true,
      beanDetailInfo: {
        productType: "",
        name: "",
        note: "",
      },
      productTypeOptions: [
        { value: "HB系列", label: "HB系列" },
        { value: "PEAK系列", label: "PEAK系列" },
      ],
      rules: {
        productType: [
          {
            required: true,
            message:
              this.$i18n.locale === "en-US"
                ? "Please select product type"
                : "请选择产品类别",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message:
              this.$i18n.locale === "en-US"
                ? "Name input error"
                : "名称输入错误",
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message:
              this.$i18n.locale === "en-US"
                ? "Comments input error"
                : "备注输入错误",
            trigger: "blur",
          },
        ],
      },
      recommend: false,
      reportList: [],
      reportPage: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
      detailReport: {
        name: "",
        level: "",
        type: "",
        weight: 0,
        color: "",
        user: {},
        suitVo: {
          bean: {
            name: "",
          },
          lineVoList: [], //曲线数据
          height: 0,
          weight: 0,
        },
      }, //曲线详情
      reportDetailDialog: false,
      selectReportId: 0,
      reportKey: 0,
      selectSuitId: 0,
      reportCommentListDialog: false,
      reportCommentList: [],
      reportCommentPage: {
        pageSize: 20,
        pageNum: 1,
        total: 0,
      },
      selectCommentId: 0,
      refreshCommentDetail: false,
      commentDetailDialog: false,
    };
  },
  mounted() {
    this.weight = "(" + localStorage.weight + ")";
    this.hasReportList = this.showReportList;
    this.setBeanDetailInfo(this.beanInfo);
    this.hasAdd = this.isAdd;
    if (this.hasReportList == true) {
      this.loadReportList();
    }
    this.checkShared();
  },
  watch: {
    $route(to) {
      console.info("to:" + to);
      this.hasReportList = this.showReportList;
      this.setBeanDetailInfo(this.beanInfo);
    },
  },
  methods: {
    setBeanDetailInfo(beanInfo) {
      this.beanDetailInfo = Object.assign(
        {
          productType: "",
          name: "",
          note: "",
        },
        beanInfo
      );
    },
    saveBeanClick() {
      this.$refs["beanAddSaveForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm(
            this.$t("m.alert.saveConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();
              params.append("id", this.beanDetailInfo.id);
              params.append("productType", this.beanDetailInfo.productType);
              params.append("name", this.beanDetailInfo.name);
              params.append("note", this.beanDetailInfo.note);

              this.$http
                .post("/manage/deviceType/update.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.updateSuccess"));
                      this.$router.go(0);
                    } else {
                      this.$message.error(this.$t("m.alert.updateError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        } else {
          console.info("表单验证失败" + valid);
        }
      });
    },
    addBeanClick() {
      this.$refs["beanAddSaveForm"].validate((valid) => {
        if (valid) {
          console.info("表单验证通过");
          this.$confirm(
            this.$t("m.alert.addConfirm"),
            this.$t("m.alert.reminder"),
            {
              confirmButtonText: this.$t("m.alert.confirm"),
              cancelButtonText: this.$t("m.alert.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              let params = new URLSearchParams();
              params.append("productType", this.beanDetailInfo.productType);
              params.append("name", this.beanDetailInfo.name);
              params.append("note", this.beanDetailInfo.note);

              this.$http
                .post("/manage/deviceType/add.do", params)
                .then(
                  function(resp) {
                    if (resp.data.success) {
                      this.$message.success(this.$t("m.alert.addSuccess"));
                      this.$router.go(0);
                    } else {
                      this.$message.error(this.$t("m.alert.addError"));
                    }
                  }.bind(this)
                )
                .catch((err) => {
                  console.info(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: this.$t("m.alert.canceled"),
              });
            });
        }
      });
    },
    beanDeleteClick() {
      this.deleteBatch(this.beanDetailInfo.id);
    },
    deleteBatch(ids) {
      this.$confirm(
        this.$t("m.alert.deleteConfirm"),
        this.$t("m.alert.reminder"),
        {
          confirmButtonText: this.$t("m.alert.confirm"),
          cancelButtonText: this.$t("m.alert.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          let params = new URLSearchParams();
          params.append("deviceTypeId", ids);
          this.$http.post("/manage/deviceType/delDeviceType.do", params).then(
            function(resp) {
              if (resp.data.success) {
                this.$message.success(this.$t("m.alert.deleteSuccess"));
                this.$router.go(0);
              }
            }.bind(this)
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("m.alert.cancelDelete"),
          });
        });
    },
  },
};
</script>

<style scoped></style>
